<template>
  <q-card class="category-card">
    <q-card-section 
      class="card-header"
      :class="headerClass"
      :style="{ cursor: hasContent ? 'pointer' : 'default' }"
      @click="toggleCategory"
    >
      <div class="row items-center justify-between">
        <div class="text-subtitle1" v-html="category.title"></div>
        <q-icon 
          v-if="hasContent"
          :name="isExpanded ? 'expand_less' : 'expand_more'" 
          size="md" 
        />
      </div>
    </q-card-section>

    <q-slide-transition>
      <q-card-section v-show="isExpanded && hasContent" class="card-content">
        <div v-if="category.description" class="description q-mb-md">
          {{ category.description }}
        </div>
        <div class="row justify-between">
          <q-btn 
            flat 
            dense 
            italic
            :color="$q.dark.isActive ? 'grey-6' : 'brown-6'"
            :label="$t('Show in Map')" 
            style="font-style: italic"
            @click.stop="openSurf" 
          />
          <q-btn 
            flat 
            dense 
            :color="$q.dark.isActive ? 'grey-6' : 'brown-6'"
            :label="$t('Metadata')" 
            style="font-style: italic"
            @click.stop="openMetadata" 
          />
        </div>
      </q-card-section>
    </q-slide-transition>
  </q-card>
</template>

<script setup>
import { computed } from 'vue'
import { useQuasar } from 'quasar'

const props = defineProps({
  category: { type: Object, required: true },
  expandedCategoryId: { type: [String, Number], default: null },
  colorIndex: { type: Number, default: 0 }
})

const emit = defineEmits(['toggle-category', 'open-surf'])

const $q = useQuasar()

const cardColor = computed(() => {
  const isEven = props.colorIndex % 2 === 0
  const baseColor = isEven ? 'green' : 'brown'
  return $q.dark.isActive ? `${baseColor}-8` : `${baseColor}-6`
})

const headerClass = computed(() => `bg-${cardColor.value} text-white`)

const isExpanded = computed(() => props.expandedCategoryId === props.category.id)

const hasContent = true

const toggleCategory = () => {
  emit('toggle-category', props.category.id)
}

const openSurf = () => {
  if (!props.category.layerId) {
    console.warn('No layerId for category:', props.category.title)
    return
  }
  
  emit('open-surf', {
    layerId: props.category.layerId,
    categoryTitle: props.category.title,
    categoryId: props.category.id
  })
}

const openMetadata = () => {
  if (props.category.metadata) {
    window.open(props.category.metadata, '_blank')
  }
}
</script>

<style lang="scss" scoped>
.category-card {
  border-radius: var(--radius-md);
  overflow: hidden;

  body.body--dark & {
    background: $dark;
  }
}

.card-header {
  transition: filter 0.2s;

  &:hover {
    filter: brightness(1.1);
  }
}

.card-content {
  body.body--dark & {
    background: $dark;
  }
}

.description {
  font-size: 0.875rem;
  line-height: 1.5;
  color: $grey-8;

  body.body--dark & {
    color: $grey-4;
  }
}

:deep(.q-btn) {
  text-transform: none;
}
</style>